import { a as __awaiter } from '../../../tslib.es6-c563c1dd.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { useSnackbar } from 'notistack';
import { styled } from '@mui/material/styles';
import { Box, ButtonBase, Hidden, Typography, Menu, MenuItem } from '@mui/material';
import { AvatarSwitch } from '../../../components/AvatarSwitch.js';
import { Debugger } from './Debugger/index.js';
import '../../../utils/getInitials.js';
import 'moment';
import '../../../utils/msToTime.js';
import './Debugger/DebugFile.js';
import 'react-feather';
import '../../../utils/clipboardCopy.js';

const PREFIX = 'Account';
const classes = {
    popover: `${PREFIX}-popover`,
};
const Root = styled('div')(() => ({
    [`& .${classes.popover}`]: {
        width: 200,
    },
}));
const Account = ({ user, logService, logAxios, logMonitorUrl, logout, }) => {
    const history = useHistory();
    const ref = useRef(null);
    const { enqueueSnackbar } = useSnackbar();
    const [isOpen, setOpen] = useState(false);
    const [isDebuggerOpen, setDebuggerOpen] = useState(false);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleLogout = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            handleClose();
            yield logout();
            history.push('/');
        }
        catch (error) {
            enqueueSnackbar('Unable to logout', {
                variant: 'error',
            });
        }
    });
    const handleOpenDebugger = () => {
        setDebuggerOpen(true);
    };
    return (jsxs(Root, { children: [jsxs(Box, Object.assign({ display: "flex", alignItems: "center", component: ButtonBase, onClick: handleOpen, ref: ref }, { children: [jsx(AvatarSwitch, { user: user }), jsx(Hidden, Object.assign({ mdDown: true }, { children: jsx(Typography, Object.assign({ variant: "h6", color: "inherit" }, { children: user.name })) }))] })), jsxs(Menu, Object.assign({ onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }, keepMounted: true, PaperProps: { className: classes.popover }, anchorEl: ref.current, open: isOpen }, { children: [logService && (jsx(MenuItem, Object.assign({ onClick: handleOpenDebugger }, { children: "Depurador" }))), jsx(MenuItem, Object.assign({ onClick: handleLogout }, { children: "Logout" }))] })), logService && (jsx(Debugger, { open: isDebuggerOpen, setOpen: setDebuggerOpen, logService: logService, logAxios: logAxios, logMonitorUrl: logMonitorUrl }))] }));
};

export { Account };
